import React from 'react';
import ReactDOMClient from 'react-dom/client';
import singleSpaReact from 'single-spa-react';

import App from './App';

const lifecycles = singleSpaReact({
  React,
  ReactDOMClient,
  rootComponent: App,
  errorBoundary() {
    return null;
  },
});

export const { bootstrap, mount, unmount } = lifecycles;

export { useFeatureFlag } from './hooks/useFeatureFlag';
export type { FeatureFlags } from './providers/FeatureFlag';
